import React, { Component } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { triggerShowReportDialog } from 'Modules/Shared/actions/errors';
import { ERROR_TYPES } from 'Modules/Shared/constants';
import { getErrorType, getError } from 'Modules/Error/selectors';
import { isUserHealthy } from 'Modules/Shared/selectors/users/health';
import { Button, Text } from '@clari/iris-react';
import { getIsGoogleUser } from '../../../Shared/selectors/users';
import { history } from 'Utils/history';

@connect(
  state => ({
    error: getError(state),
    isUserHealthy: isUserHealthy(state),
    isGoogleUser: getIsGoogleUser(state),
    errorType: getErrorType(state),
  }),
  {
    triggerShowReportDialog,
  }
)
export default class ModuleRoot extends Component {
  static propTypes = {
    error: PropTypes.instanceOf(window.Error),
    errorType: PropTypes.oneOf(Object.values(ERROR_TYPES)),
    isGoogleUser: PropTypes.bool,
    isUserHealthy: PropTypes.bool,
  };

  static defaultProps = {
    error: null,
    errorType: null,
    isGoogleUser: false,
    isUserHealthy: false,
  };

  componentDidMount() {
    if (this.props.isUserHealthy) {
      history.push('/');
    }
    window.addEventListener('message', this.handleMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage);
  }

  handleMessage(event) {
    if (event.data.action === 'EXTENSION/AUTH_FLOW_COMPLETE') {
      localStorage.removeItem('REACT_QUERY_OFFLINE_CACHE');
      window.location.href = '/groove';
    }
  }

  render() {
    const { isGoogleUser } = this.props;
    return (
      <div className="flex flex-col items-center justify-center h-[calc(100vh-58px)] gap-2">
        <svg
          width="153"
          height="156"
          viewBox="0 0 153 156"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#ofhg01wusa)">
            <path
              d="M91.775 0a23.223 23.223 0 0 0-16.468 6.848 23.481 23.481 0 0 0-6.83 16.55 23.52 23.52 0 0 0 1.777 8.96 23.417 23.417 0 0 0 5.052 7.593 23.273 23.273 0 0 0 7.557 5.07 23.171 23.171 0 0 0 8.912 1.776 23.174 23.174 0 0 0 8.911-1.777 23.275 23.275 0 0 0 7.555-5.071 23.43 23.43 0 0 0 5.051-7.593 23.479 23.479 0 0 0-5.053-25.506A23.22 23.22 0 0 0 91.775 0z"
              fill="#5F3ADA"
            />
            <path
              d="M102.855 105.41a49.681 49.681 0 0 0-20.635 4.455l7.528 13.106-35.55 20.636a50.796 50.796 0 0 0-1.487 12.218v.181h50.313l49.97-.181c0-13.371-5.283-26.195-14.686-35.649a49.995 49.995 0 0 0-35.453-14.766z"
              fill="#037EFB"
            />
            <path
              d="M82.221 109.865 56.884 65.757.018 98.792l32.847 57.214 21.35-12.399a50.635 50.635 0 0 1 10.164-20.092 50.284 50.284 0 0 1 17.842-13.65z"
              fill="#00D7B8"
            />
          </g>
          <defs>
            <clipPath id="ofhg01wusa">
              <path fill="#fff" d="M0 0h153v156H0z" />
            </clipPath>
          </defs>
        </svg>

        <div className="mt-2">
          <Text variant="body" weight="bold">
            You have been disconnected from{' '}
            {isGoogleUser ? 'Google' : 'Microsoft'} or Salesforce.
          </Text>
        </div>
        <div className="mb-2">
          <Text variant="body">
            Click Connect to continue using Groove in Clari.
          </Text>
        </div>
        <Button
          tone="accent"
          variant="solid"
          onClick={() => {
            window.postMessage(
              {
                type: 'RECONNECT_GROOVE',
                payload: {},
                meta: {
                  target: 'omnibar',
                },
              },
              '*'
            );
          }}
        >
          Connect
        </Button>
      </div>
    );
  }
}
